// Fuente única del texto de Términos y Condiciones: de acá se genera tanto
// el render visual (TerminosYCondiciones.js) como el texto plano que se
// guarda como constancia de lo que el usuario aceptó al registrarse.

export const TERMINOS_Y_CONDICIONES_BLOQUES = [
  {
    type: 'meta',
    text: 'Última actualización: 2026. Al crear una cuenta en CtaCte App aceptás los siguientes términos y condiciones. Leelos con atención antes de continuar.'
  },
  { type: 'header', text: '1. Objeto del servicio' },
  {
    type: 'paragraph',
    text: 'CtaCte App es una herramienta de gestión de cuenta corriente, cuentas, movimientos y comprobantes provista "tal cual" (as is), para que cada usuario administre su propia información contable y comercial. No somos un servicio de asesoría contable, impositiva ni legal.'
  },
  { type: 'header', text: '2. Registro y responsabilidad de la cuenta' },
  {
    type: 'paragraph',
    text: 'Sos responsable de proporcionar datos veraces al registrarte, de mantener la confidencialidad de tu contraseña y de toda actividad que ocurra bajo tu usuario. Debés notificarnos ante cualquier uso no autorizado de tu cuenta del que tomes conocimiento.'
  },
  { type: 'header', text: '3. Período de prueba y suscripción' },
  {
    type: 'paragraph',
    text: 'El servicio incluye un período de prueba gratuito de 15 (quince) días corridos desde el registro. Finalizado ese período, el acceso queda sujeto al pago de la suscripción mensual vigente al momento de cada renovación. El valor de la suscripción puede actualizarse en el futuro; los cambios no tienen efecto retroactivo sobre pagos ya realizados.'
  },
  { type: 'header', text: '4. Responsabilidad sobre la información cargada' },
  {
    type: 'paragraph',
    text: 'Vos sos el único responsable de la información que generás, cargás, procesás o almacenás dentro de la aplicación (incluyendo datos de clientes, proveedores, movimientos, comprobantes y cualquier otro contenido). CtaCte App no controla, valida ni se hace responsable por la exactitud, legalidad o licitud de esos datos, ni por el uso que vos o terceros autorizados por vos les den dentro o fuera de la plataforma.'
  },
  { type: 'header', text: '5. Limitación de responsabilidad' },
  {
    type: 'paragraph',
    text: 'En la máxima medida permitida por la ley aplicable, CtaCte App, sus responsables y desarrolladores no serán responsables por:'
  },
  {
    type: 'list',
    items: [
      'El mal uso, uso indebido, pérdida, alteración o divulgación de la información generada, procesada o almacenada en la aplicación, ya sea por vos, por otros usuarios de tu cuenta o por terceros.',
      'Incidentes de seguridad, accesos no autorizados, filtraciones o fugas de datos que excedan las medidas de seguridad razonables adoptadas por el servicio, incluyendo aquellos originados por vulnerabilidades de terceros (proveedores de hosting, infraestructura, pasarelas de pago, etc.).',
      'Daños directos, indirectos, incidentales o consecuentes derivados del uso o la imposibilidad de uso de la aplicación, incluyendo pérdida de datos, de ganancias o interrupciones del negocio.',
      'Decisiones comerciales, contables, impositivas o legales que tomes en base a la información registrada en la aplicación.'
    ]
  },
  {
    type: 'paragraph',
    text: 'El servicio se brinda "tal cual está disponible", sin garantías de ningún tipo, expresas o implícitas, sobre su funcionamiento ininterrumpido o libre de errores.'
  },
  { type: 'header', text: '6. Seguridad y resguardo de datos' },
  {
    type: 'paragraph',
    text: 'Aplicamos medidas de seguridad razonables para proteger la información almacenada, pero ningún sistema es 100% infalible. Te recomendamos mantener copias propias de la información crítica de tu negocio y no compartir tus credenciales de acceso con terceros.'
  },
  { type: 'header', text: '7. Suspensión y baja de cuenta' },
  {
    type: 'paragraph',
    text: 'Podemos suspender o dar de baja tu acceso ante falta de pago de la suscripción, uso indebido de la plataforma, incumplimiento de estos términos, o por decisión unilateral debidamente justificada. La baja de la cuenta no implica necesariamente la eliminación inmediata de los datos históricos.'
  },
  { type: 'header', text: '8. Modificaciones' },
  {
    type: 'paragraph',
    text: 'Estos términos pueden actualizarse en el futuro. Los cambios relevantes se comunicarán por los medios de contacto que hayas registrado o dentro de la propia aplicación.'
  },
  { type: 'header', text: '9. Legislación aplicable' },
  {
    type: 'paragraph',
    text: 'Estos términos se rigen por las leyes de la República Argentina. Cualquier controversia se someterá a los tribunales ordinarios competentes, con renuncia a cualquier otro fuero o jurisdicción.'
  },
  {
    type: 'disclaimer',
    text: 'Este texto es un modelo general y no reemplaza el asesoramiento de un abogado. Se recomienda su revisión legal antes de publicarlo definitivamente.'
  }
];

export const getTerminosYCondicionesTexto = () => TERMINOS_Y_CONDICIONES_BLOQUES
  .map((bloque) => {
    if (bloque.type === 'list') {
      return bloque.items.map((item) => `- ${item}`).join('\n');
    }
    return bloque.text;
  })
  .join('\n\n');
